import { createContext, useContext } from 'react';
import { DataGridProps } from './data-grid';

const DataGridContext = createContext<DataGridProps<{}> | undefined>(null);

export const useDataGridContext = () => {
	const dataGridContext = useContext(DataGridContext);
	if (!dataGridContext) {
		throw new Error('No Data Grid Context Provided. Are you using this outside of a DataGrid component?');
	}
	return dataGridContext;
};

export const DataGridContextProvider = DataGridContext.Provider;

const DataGridDataContext = createContext<unknown[]>(undefined);

export const DataGridDataContextProvider = DataGridDataContext.Provider;

export const useDataGridDataContext = <T extends object = {}>(): T[] => {
	const dataGridContext = useContext(DataGridDataContext);
	if (!dataGridContext) {
		throw new Error('No Data Grid Data Context Provided. Are you using this outside of a DataGrid component?');
	}
	return dataGridContext as T[];
};
